import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import PolicyIcon from "@mui/icons-material/Policy";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function CustomizedDialogs() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <ListItemButton onClick={handleClickOpen}>
        <ListItemIcon>
          <PolicyIcon />
        </ListItemIcon>
        <ListItemText primary={"Política de Privacidade"} />
      </ListItemButton>
      <BootstrapDialog
        onClose={handleClose}
        style={{ zIndex: 9999999999 }}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Política de Privacidade
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
            Para sua segurança, nenhum dado de localização é armazenado em nossos bancos de dados, estas informações são utilizadas apenas para o processamento das rotas, distância e tempo dos destinos selecionados.
          </Typography>
          <br />
          <Typography gutterBottom>
            Não nos  responsabilizamos por valores que estão em inconsistência com o posto, pois estes dados são fornecidos pelo governo federal.
          </Typography>
          <br />
          <Typography gutterBottom>
            Caso possua dúvidas, sugestões ou reclamações entre em contato conosco pelo Instagram.
          </Typography>
          <br />
          <Typography gutterBottom>
            Nosso site no momento fornece informações apenas do estado de Goiás.
          </Typography>
          <br />
          <Typography gutterBottom>
            O site Postos GO não possui vínculo governamental, trata-se de uma iniciativa privada.
          </Typography>
          <br />
          <Typography gutterBottom fontSize={14}>
            Postos GO ® Todos os Direitos Reservados.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Fechar
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
